import { z } from "zod";

export const API_URL = "https://api-giveaway.ezid.sg/";
export const DOMAIN = "https://giveaway.ezid.sg";
export const WEBSOCKET_URL = "wss://api-giveaway.ezid.sg/v1/user/referral_tracking";

const MAX_FILE_SIZE = 4 * 1000000;
export const ACCEPTED_TYPES = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "image/jpg",
];

export const fileSchema = z
  .any()
// Validate accepted file types
  .refine((file) => {
    return ACCEPTED_TYPES.includes(file?.type);
  }, {
    message: "Please upload .jpg, .png or .pdf file.",
  })
// Validate file size
  .refine((file) => file && file?.size <= MAX_FILE_SIZE, {
    message: "Max file size is 4MB.",
  });
